import React, { useState } from "react";
import {
	TwitterShareButton,
	FacebookShareButton,
	WhatsappShareButton,
	LinkedinShareButton,
	EmailShareButton
} from "react-share";

const ShareButton = ({ url, content, emailSubject ,isIcon}) => {
	return (
		<>
			<div className="dropdown">
				<button
					className="btn-share dropdown-toggle"
					type="button"
					id="dropdownMenuButton1"
					data-bs-toggle="dropdown"
					aria-expanded="false"
				>
				{isIcon?<img className={`share-dynamic-icon`} src="/img/share-white.svg" alt="Share Icon" />:<img className={`share-main-icon`} src="/img/share-icon.svg" alt="Share Icon" />}	
				</button>
				<ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
					<li>
						<EmailShareButton
							subject={emailSubject ? emailSubject : ""}
							body={content ? content : ""}
							url={url ? url : ""}
						>
							<img className="share-icons" src="/img/mail-black.svg" alt="Email" />
						</EmailShareButton>
					</li>
					<li>
						<WhatsappShareButton title={content ? content : ""} url={url ? url : ""}>
							<img
								className="share-icons"
								src="/img/whatsapp-black.svg"
								alt="Whatsapp"
							/>
						</WhatsappShareButton>
					</li>
					<li>
						<FacebookShareButton quote={content ? content : ""} url={url ? url : ""}>
							<img className="share-icons" src="/img/fb-black.svg" alt="Facebook" />
						</FacebookShareButton>
					</li>
					<li>
						<TwitterShareButton title={content ? content : ""} url={url ? url : ""}>
							<img
								className="share-icons"
								src="/img/event-card-twitter.svg"
								alt="Twitter"
							/>
						</TwitterShareButton>
					</li>
					<li>
						<LinkedinShareButton summary={content ? content : ""} url={url ? url : ""}>
							<img
								className="share-icons"
								src="/img/lnkdin-black.svg"
								alt="Linkdin"
							/>
						</LinkedinShareButton>
					</li>
				</ul>
			</div>
			<style>
				{`
                    .dropdown-menu {
                        margin-top: 0px !important;
                        text-align: center;
                        // display: flex;
						right: 0 !important;
					   bottom: -14px!important;
   						 left: 1px !important;
						 transform: translate3d(-159px, 28px, 11px) !important;
						 inset: 0 0 -10px !important;
                    }
                    .dropdown-menu {
                        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
                    }
                    .dropdown-menu > li {
                        display: inline-block;
                        margin-left: 8px;
                        margin-righ: 8px;
                    }
                    .btn-share {
                        background: transparent;
                        border: none;
                    }
                    .dropdown-toggle::after {
                        display: none;
                    }
                    .share-icons,.share-dynamic-icon, .share-main-icon{
                        height: 18px;
                        width: 18px;
                        cursor:pointer;
                    }
                    .share-icons {
                        filter: invert(0.1);
                    }
                    .share-main-icon {
                        filter: invert(0.5);
                    }
                    .share-main-icon {
                        filter: invert(0.5);
                    }
                    .btn-share:focus {
                        box-shadow: none !important;
                    }
                    .show .share-main-icon {
                        filter: invert(1);
                    }
                    .share-main-icon:hover {
                        filter: invert(1);
                        transition: invert .15s ease-in-out, color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
                    }
                    .share-icons:hover{
                        filter: invert(40%) sepia(40%) saturate(1052%) hue-rotate(316deg) brightness(110%) contrast(98%);
                        transition: invert .15s ease-in-out, color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
                    }   
                `}
			</style>
		</>
	);
};

export default ShareButton;